import React from "react"
import { useIntl } from "react-intl"
import { AxiosError } from "axios"
import DisplayError from "../DisplayError"
import {
	getErrorOrNoData,
	hasErrorOrNotData,
} from "./AsyncMessageResponseHandler.utils"
import { textRetryButton } from "./AsyncMessageResponseHandler.constants"
import "./AsyncMessageResponseHandler.styles.scss"
import { Card } from "@walmart-web/livingdesign-components"

type MessageResponseProps = {
	error: AxiosError<any> | null
	isLoading: boolean
	isError: boolean
	hasData?: boolean
	className?: string
	children?: React.ReactNode | undefined
	retry?: () => void
}

const AsyncMessageResponseHandler = ({
	className,
	children,
	error,
	isError,
	isLoading,
	hasData = true,
	retry = () => undefined,
}: MessageResponseProps) => {
	const intl = useIntl()

	if (!hasErrorOrNotData(isError, hasData) || isLoading) {
		return <>{children}</>
	}

	const errorResponse = getErrorOrNoData(error)
	const { img, hasRetry, ...errorMessage } = errorResponse

	return (
		<Card className={`error-container ${className}`}>
			<DisplayError
				error={errorMessage}
				img={img}
				hasRetry={hasRetry}
				actionRetryButton={retry}
				descriptionRetryButton={intl.formatMessage(textRetryButton)}
			/>
		</Card>
	)
}

export default AsyncMessageResponseHandler
